var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewodficon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Action Icons",
    clipPath: "url(#clip0_5058_4912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.6651 0.5C7.28763 0.512746 9.27842 3.0022 9.93696 6.65158C9.95672 6.74317 9.97285 6.83685 9.98531 6.932C10.0378 7.4595 9.94337 7.78502 9.71842 7.86248C9.48531 7.9419 9.32852 7.73012 9.23236 7.21536C8.70377 4.37195 7.58541 2.56883 5.85221 1.95504C3.64462 1.17065 1.43706 3.4395 0.789582 7.07417C0.769767 7.18301 0.75578 7.29479 0.731303 7.40264C0.652045 7.78895 0.483596 7.95367 0.255145 7.84974C0.043594 7.75169 -0.0315852 7.47912 0.00746134 7.11438C0.123321 6.0864 0.374205 5.11494 0.741775 4.27096C1.78846 1.79915 3.22912 0.5804 4.6651 0.5Z",
    fill: "#E10098"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.99024 10.5C4.58215 10.4961 4.1839 10.2889 3.84573 9.9046C3.50757 9.52026 3.24466 8.97598 3.09019 8.34048C2.93572 7.70497 2.89662 7.00672 2.97782 6.33386C3.05901 5.661 3.25686 5.04368 3.5464 4.55983C3.83594 4.07598 4.20418 3.74728 4.60466 3.61523C5.00514 3.48318 5.4199 3.55369 5.79658 3.81786C6.17326 4.08203 6.495 4.52802 6.72115 5.09954C6.94731 5.67105 7.06775 6.34248 7.0673 7.02907C7.06661 7.48654 7.01231 7.93929 6.90751 8.36141C6.80272 8.78354 6.64949 9.16675 6.45657 9.48914C6.26365 9.81152 6.03484 10.0667 5.78324 10.2402C5.53163 10.4136 5.26215 10.5019 4.99024 10.5ZM6.29511 7.02711C6.2974 6.59655 6.22374 6.17451 6.08345 5.81438C5.94316 5.45426 5.74254 5.17222 5.50695 5.00396C5.27137 4.83571 5.01141 4.78878 4.75998 4.86912C4.50854 4.94946 4.27693 5.15345 4.09441 5.4553C3.9119 5.75716 3.78669 6.1433 3.73464 6.56488C3.68259 6.98647 3.70603 7.42455 3.802 7.82372C3.89796 8.22289 4.06213 8.56521 4.27374 8.80738C4.48536 9.04954 4.73492 9.18068 4.99084 9.18419C5.33318 9.18554 5.66206 8.95989 5.9062 8.55612C6.15033 8.15236 6.29005 7.60301 6.29511 7.02711Z",
    fill: "#E10098"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5058_4912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewodficon);
export default __webpack_public_path__ + "static/media/viewodficon.1b1080b3c999dc3d6855cf94cc480568.svg";
export { ForwardRef as ReactComponent };